import * as React from 'react';
import Money from '../Money';
import { getLabel } from './utils';

interface Props {
	amount?: number;
	moneyClassName?: string;
	amountClassName?: string;
	currencyClassName?: string;
}

const PriceInMiles: React.FC<Props> = ({ amount, moneyClassName, amountClassName, currencyClassName }) => {
	return (
		<Money
			money={{
				amount: amount,
				currency: 'miles'
			}}
			currencyRenderer={() => {
				return (
					<span style={{ paddingLeft: '4px' }} className={currencyClassName}>
						{getLabel(amount)}
					</span>
				);
			}}
			amountClassName={amountClassName}
			moneyClassName={moneyClassName}
			currencyClassName={currencyClassName}
		/>
	);
};

export default PriceInMiles;
